import React from 'react'
import Img from 'gatsby-image'
import Link from 'gatsby-link'
import Button from '../../components/Button'
import Reviews from '../../components/Reviews'
import Card from '../../components/Card'

import mp4 from '../../assets/augusta-intro.mp4'
import webm from '../../assets/augusta-intro.webm'

import pages from '../../data/pages'

import s from './styles.module.css'

const HomeTemplate = ({ logo, data, locale, i18n }) => (
  <div className={s.wrapper}>
    <section className={s.landingSection}>
      <div className={s.landingVideo}>
        <video
          autoPlay
          loop
          playsInline
          muted
          poster={data.landingImage.sizes.src}
          style={{
            width: '100%',
            height: '100%',
            backgroundSize: 'cover',
            backgroundRepat: 'no-repeat',
            objectFit: 'cover'
          }}
        >
          <source src={webm} type="video/webm; codecs=vp9,vorbis" />
          <source src={mp4} type="video/mp4" />
        </video>
      </div>
      {logo ? <Img className={s.logo} sizes={logo.sizes} /> : null}
      <h1 className={s.headerTitle}>{i18n('landingSectionTitle')}</h1>
      <h3 className={s.subtitle}>{i18n('landingSectionSubtitle')}</h3>
      <Button className={s.bookNowButton} anchor="contact-btns">
        {i18n('bookNow')}
      </Button>
    </section>

    <section className={s.cards}>
      {Array.from(pages.values(), ({ to, text, image }) => (
        <Card
          key={to}
          to={`/${locale}${to}`}
          text={i18n(text)}
          image={data[image]}
        />
      ))}
    </section>

    <section className={s.paragraph} id="contact-btns">
      <h2 className={s.title}>{i18n('paragraphTitle')}</h2>
      <p className={s.description}>{i18n('paragraphDescription')}</p>
      <div className={s.bookButtons}>
        <Link to={`/${locale}${pages.get('restaurant').to}#contact-form`}>
          <Button className={s.readMoreButton}>{i18n('bookRestaurant')}</Button>
        </Link>
        <Link to={`/${locale}${pages.get('accommodation').to}#contact-form`}>
          <Button className={s.readMoreButton}>{i18n('bookVilla')}</Button>
        </Link>
        <Link to={`/${locale}${pages.get('docking').to}#contact-form`}>
          <Button className={s.readMoreButton}>{i18n('bookDock')}</Button>
        </Link>
      </div>
    </section>

    <Reviews title={i18n('testimonials')} image={data.testimonialsImage} />
  </div>
)

export default HomeTemplate

export const homeImagesFragment = graphql`
  fragment HomeImages on RootQueryType {
    landingImage: imageSharp(id: { regex: "/poster.jpg/" }) {
      sizes(maxWidth: 1280) {
        ...GatsbyImageSharpSizes_withWebp
      }
    }

    testimonialsImage: imageSharp(id: { regex: "/testimonials/" }) {
      sizes(maxWidth: 1180) {
        ...GatsbyImageSharpSizes_withWebp
      }
    }

    restaurantCardImage: imageSharp(id: { regex: "/card_restaurant/" }) {
      sizes(maxWidth: 318) {
        ...GatsbyImageSharpSizes_withWebp
      }
    }

    dockingCardImage: imageSharp(id: { regex: "/card_docking/" }) {
      sizes(maxWidth: 318) {
        ...GatsbyImageSharpSizes_withWebp
      }
    }

    accommodationCardImage: imageSharp(id: { regex: "/card_accommodation/" }) {
      sizes(maxWidth: 318) {
        ...GatsbyImageSharpSizes_withWebp
      }
    }

    toursCardImage: imageSharp(id: { regex: "/card_adventure/" }) {
      sizes(maxWidth: 318) {
        ...GatsbyImageSharpSizes_withWebp
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/Home/index.js